import gql from "graphql-tag";

export const CONFIRM_SHIPMENT_REQUEST_MUTATION = gql`
  mutation ConfirmShipmentRequestMutation(
    $params: ShipmentRequestParams!
  ){
    confirmShipmentRequest(
      params: $params
    ) {
      code
    }
  }
`;
